module.exports = __webpack_public_path__ + "static/finovate-spring-2015-8e3381291f90bb1384950c72124a26d0.webp";